import { CheckedSquareIcon } from "../../../constants/IconData"

const CustomIcon = (props) => {
    const { isChecked } = props
    return (
        isChecked ? <CheckedSquareIcon /> : null
    )
}
export default CustomIcon